export const styles = {
  notificationItem: (theme) => ({
    cursor: "pointer",
    p: 1,
    borderRadius: "5px",
    position: "relative",
    pr: 1.8745,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
    width: "100%",
    "&:hover": {
      backgroundColor: theme.palette.background.hover,
    },
  }),
  unreadNotification: (theme) => ({
    backgroundColor: theme.palette.background.activity,
    "&:before": {
      content: '""',
      position: "absolute",
      right: 7,
      top: 15,
      width: 14,
      height: 14,
      borderRadius: 10,
      backgroundColor: theme.palette.primary.main,
    },
  }),
  avatar: {
    width: 52,
    height: 52,
  },
  notificationItemContent: {
    width: "calc(100% - 56px)",
    pl: 1.8745,
    flexWrap: "nowrap",
    justifyContent: "flex-start",
  },
  notificationTitle: {
    fontSize: 14,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontWeight: "bold",
  },
  notificationItemAction: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: 14,
  }),
  notificationItemDate: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: 10,
    fontWeight: "bold",
  }),
}
